import Reveal, { Eyebrow } from "./Reveal";
import { Wash, Sprig } from "./Watercolor";

const TRIO_IMG =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_custom-umbrellas/artifacts/c5bc314f681b4c0e_IMG_2994.jpeg";
export const SKY_IMG =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_custom-umbrellas/artifacts/8bef83a90902b864_IMG_3003.jpeg";

export default function PaletteBand() {
  return (
    <section className="relative py-24 sm:py-28" data-testid="palette-section">
      <Wash color="#A3B18A" size={460} opacity={0.26} className="-top-20 -left-32" />
      <Sprig color="#FFD166" leaf="#7D9B76" flip className="hidden lg:block bottom-4 right-[4%] w-24" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-8 lg:gap-12 lg:grid-cols-12 items-end">
          <Reveal className="lg:col-span-8">
            <div className="overflow-hidden rounded-3xl border-4 border-white shadow-2xl shadow-moss/10 bg-peach">
              <img
                src={TRIO_IMG}
                alt="Three floral umbrella palettes — peony pink, midnight mum and lavender mist"
                loading="lazy"
                className="aspect-[16/10] w-full object-cover"
                data-testid="palette-trio-image"
              />
            </div>
          </Reveal>
          <Reveal className="lg:col-span-4" delay={0.12}>
            <Eyebrow>From the sketchbook</Eyebrow>
            <h2 className="mt-4 font-serif font-medium tracking-tight text-ink text-3xl sm:text-4xl">
              Pick a palette. Or invent your own.
            </h2>
            <p className="mt-4 text-ink/70 leading-relaxed" data-testid="palette-copy">
              Peony pink, midnight mum, lavender mist — every umbrella starts as a colour
              story. Bring us a photo, a wedding theme or a feeling, and we'll mix the
              paints to match.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
